/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable arrow-body-style */
import {
 Autocomplete,
 AutocompletePropsSizeOverrides,
 CircularProgress,
 TextField,
} from '@mui/material';
import { useState } from 'react';
import { Control, Controller, SetValueConfig } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { post } from '../../api/api';
import { ReportType } from '../../redux/reports/reportsSlice';
import { FormValues } from '../../types/types';
import { OverridableStringUnion } from '@mui/types';

const SelectApiManual = ({
 required,
 name,
 url,
 filterVar,
 fixedFilters,
 limit,
 label,
 isEditable,
 control,
 setValue,
 disabled = false,
 size = 'small',
}: {
 required?: boolean;
 name: string;
 url: string;
 filterVar: string;
 fixedFilters?: [
  {
   field: string;
   operator: string;
   value: string;
   logic?: string;
  },
 ];
 limit?: number;
 label: string;
 isEditable: boolean;
 control: Control<FormValues, any>;
 setValue: (
  name: string,
  value: ReportType | null,
  options: SetValueConfig,
 ) => void;
 disabled?: boolean;
 size?:
  | OverridableStringUnion<'small' | 'medium', AutocompletePropsSizeOverrides>
  | undefined;
}) => {
 const { t } = useTranslation();
 const [options, setOptions] = useState([]);
 const [loading, setLoading] = useState(false);
 const [inputValue, setInputValue] = useState('');
 const filterName = filterVar || 'Name';

 const fetchOptions = async (val?: string) => {
  setLoading(true);
  try {
   const filtersData = val
    ? [
       ...(val
        ? [
           {
            field: filterName,
            operator: 'contains',
            value: val,
            logic: 'And',
           },
          ]
        : []),
       ...(fixedFilters || []),
      ]
    : fixedFilters || [];
   //  console.log(filtersData);

   if (Array.isArray(filtersData) && filtersData.length > 1) {
    filtersData[0].logic = 'And';
   }
   if (filtersData[filtersData.length - 1]?.logic) {
    delete filtersData[filtersData.length - 1]?.logic;
   }

   const response = await post(url.replace('/api', ''), {
    // ...apiParams,
    filters: filtersData,
    limit: limit || 10,
   });

   setOptions(response.data || []);
  } catch (error) {
   console.error('Failed to load options:', error);
   setOptions([]);
  } finally {
   setLoading(false);
  }
 };

 return (
  control && (
   <Controller
    name={name}
    control={control}
    defaultValue="" // Default value for controlled input
    rules={{
     required: required ? `${label} ${t('global.isRequired')}` : false,
    }}
    render={({ field, fieldState }) => {
     return (
      <Autocomplete
       size={size || 'small'}
       sx={{
        width: '100%',
       }}
       onOpen={() => {
        console.log('onOpen');
        if (!options.length) {
         fetchOptions(inputValue);
        }
       }}
       disabled={disabled || !isEditable}
       value={field.value}
       onChange={(e: any, value: ReportType) => {
        // console.log('onChange', value);
        // bad hacking but for some reason onChange works only each second time
        setValue(name, value || null, { shouldValidate: true });
        // return field.onChange(value || '');
       }}
       options={options}
       //    getOptionLabel={(option) => (option as any)?.id}
       //    renderOption={(option) => <>{(option as any)?.label}</>}
       getOptionLabel={(option: any) => {
        return (
         options.find((o) => (o as any)?.Id === (option.Id || option))?.[
          filterName
         ] ||
         option?.[filterName] ||
         ''
        ).toString();
       }}
       filterOptions={(x) => x} // Disable client-side filtering
       onInputChange={(event, value) => {
        console.log(field, value);
        if (field.value?.[filterName] === value) return;
        setInputValue(value);
        fetchOptions(value);
       }}
       isOptionEqualToValue={(option, value) => {
        return (option as any).Id === value.Id;
       }}
       loading={loading}
       renderInput={(params) => (
        <TextField
         {...params}
         label={label}
         variant="outlined"
         disabled={disabled || !isEditable}
         error={!!fieldState.error}
         helperText={
          fieldState?.error?.message ? fieldState.error.message?.toString() : ''
         }
         InputProps={{
          ...params.InputProps,
          endAdornment: (
           <>
            {loading ? <CircularProgress color="inherit" size={20} /> : null}
            {params.InputProps.endAdornment}
           </>
          ),
         }}
        />
       )}
      />
     );
    }}
   />
  )
 );
};
export default SelectApiManual;
